import { Directive, ElementRef, effect, inject, input } from '@angular/core';
import { GuideAnchors } from './guide-anchors';

/** Marks the element a guide step can point at. */
@Directive({
  selector: '[appGuideAnchor]',
})
export class GuideAnchorDirective {
  readonly appGuideAnchor = input.required<string>();
  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly anchors = inject(GuideAnchors);

  constructor() {
    effect((onCleanup) => {
      const id = this.appGuideAnchor();
      const element = this.element.nativeElement;
      this.anchors.register(id, element);
      onCleanup(() => this.anchors.unregister(id, element));
    });
  }
}
